module.exports = __webpack_public_path__ + "img/dsci0008.d5a941d7.jpg";